import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";

export default function NotFound() {
  return (
    <section className="section" style={{ textAlign: "center", padding: "120px 0" }}>
      <div className="container">
        <h1 style={{ fontSize: 120, color: "var(--yellow)", lineHeight: 1 }}>404</h1>
        <h2 style={{ fontSize: 32, margin: "10px 0 16px" }}>Page Not Found</h2>
        <p className="sec-text" style={{ maxWidth: 480, margin: "0 auto 28px" }}>
          The page you're looking for doesn't exist or has been moved.
        </p>
        <Link to="/" className="btn btn-primary"><FaHome /> Back to Home</Link>
      </div>
    </section>
  );
}
